import ApiService from "@/api/baseApi/api-service";
import { Config } from "../../config";
import { IGetFilters, IGetFiltersParams } from "./interfaces/IGetFilters";
import { IKeyValue } from "../builder/interfaces/interfaces";

const URLs = {
  getFilters: "/filters",
  getCities: "/cities",
  getAreas: "/areas",
};
class ApiFilters extends ApiService {
  constructor(config: Config) {
    super({ ...config });
  }
  getFilters = (params: IGetFiltersParams): Promise<IGetFilters> =>
    this.get(URLs.getFilters, { params });

  getCities = (params: {
    country_id: number | string;
  }): Promise<{ result: IKeyValue[] } & import("@/api/AppApi/common-interfaces/IResultStamp").IResultStamp> =>
    this.get(URLs.getCities, { params });

  getAreas = (params: {
    city_id: number | string;
  }): Promise<{ result: IKeyValue[] } & import("@/api/AppApi/common-interfaces/IResultStamp").IResultStamp> =>
    this.get(URLs.getAreas, { params });
}
export default ApiFilters;
